import React, { useEffect } from 'react'
import './style.sass'

const CopiedElement = ({ time = 3000, text = 'copied', onTimout, top, right, left, bottom, isAbsolute = true }) => {

  useEffect(() => {
    setTimeout(() => {
      onTimout()
    }, time)
  })

  return <span style={{ top, right, left, bottom, position: isAbsolute ? 'absolute' : 'relative' }} className='copied-span'>
    {text}
  </span>

}

export default CopiedElement